import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { ReactiveFormsModule } from '@angular/forms';
import { SearchBarModule } from '../../angular-core/components/search-bar/search-bar.module';
import { ListItemModule } from '../../angular-core/components/list-item/list-item.module';
import { FilterPipeModule } from 'src/app/angular-core/utils/pipes/filter/filter.pipe.module';
import { TranslateModule } from '@ngx-translate/core';
import { NewsComponent } from './news.component';
import { NewsRoutingModule } from './news-routing.module';
import { NewsItemContentComponent } from './news-item-content/news-item-content.component';
import { DialogHeaderModule } from 'src/app/angular-core/components/dialog-header/dialog-header.module';
import { LocalizedDateModule } from 'src/app/angular-core/utils/pipes/localized-date/localized-date.pipe.module';
import { MatDialogModule } from '@angular/material/dialog';


@NgModule({
  declarations: [NewsComponent, NewsItemContentComponent, ],
  imports: [
    CommonModule,
    NewsRoutingModule,
    MatIconModule,
    ReactiveFormsModule,
    MatDialogModule,
    SearchBarModule,
    FilterPipeModule,
    ListItemModule,
    TranslateModule,
    DialogHeaderModule,  
    LocalizedDateModule,
  ], 
  exports: [NewsComponent]
})
export class NewsModule { }
